module.exports = __webpack_public_path__ + "static/android-0bedb8475729c1adb87973f262c2d8b7.png";